// src/components/HRComponents/NotificationHistory.js
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../common/apiClient"; // Imported your global apiClient [1]
import SummaryApi from "../../common/SummaryApi";

const PushNotificationHistory = () => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  // FIX: Inline API retrieval using the core apiClient [1]
  const fetchHistory = async () => {
    try {
      setLoading(true);
      const res = await api.get(SummaryApi.getPushHistory.url);
      if (res.data.success) {
        setNotifications(res.data.data || []);
      }
    } catch (error) {
      console.error("Failed to load history:", error);
      toast.error("Failed to load notification history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">
          Push Notification History
        </h2>
        <button
          onClick={fetchHistory}
          className="px-4 py-2 rounded bg-blue-600 text-white"
        >
          Refresh
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-auto">
        <table className="min-w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left">Title</th>
              <th className="px-4 py-3 text-left">Message</th>
              <th className="px-4 py-3 text-left">Target</th>
              <th className="px-4 py-3 text-left">Success</th>
              <th className="px-4 py-3 text-left">Failed</th>
              <th className="px-4 py-3 text-left">Sent By</th>
              <th className="px-4 py-3 text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center py-8">
                  Loading...
                </td>
              </tr>
            ) : notifications.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center py-8">
                  No Notification History
                </td>
              </tr>
            ) : (
              notifications.map((item) => (
                <tr
                  key={item._id}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="px-4 py-3">
                    {item.title}
                  </td>
                  <td className="px-4 py-3">
                    {item.message}
                  </td>
                  <td className="px-4 py-3 capitalize">
                    {item.targetType}
                  </td>
                  <td className="px-4 py-3">
                    {item.successCount}
                  </td>
                  <td className="px-4 py-3">
                    {item.failedCount}
                  </td>
                  <td className="px-4 py-3">
                    {item.sentBy
                      ? `${item.sentBy.firstName} ${item.sentBy.lastName}`
                      : "-"}
                  </td>
                  <td className="px-4 py-3">
                    {new Date(item.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PushNotificationHistory;